import "../components/global.js";
import "../assets/css/bootstrap.css";
import Navbar from "../components/Navbar.js";
import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";

export default class Import extends Component {
  state = { type: "" };

  componentDidMount() {
    loading(false);
  }

  render() {
    const cards = [
      { icon: "\uf007", label: "รายชื่อลูกค้า", link: "/import-customer" },
      { icon: "\uf043", label: "การแจ้งหนี้และจัดเก็บค่าน้ำ", link: "/import-bill-water" },
      { icon: "\uf043", label: "การแจ้งหนี้และจัดเก็บค่าน้ำ (แบบไม่มีเลขมาตรเริ่มต้น - สิ้นสุด)", link: "/import-bill-unit-used" }
    ];

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="รายชื่อลูกค้า" />
        
        <div className="body">
          <div className="p-3">
            <h4 className="mb-3">
              <b>นำเข้าไฟล์ข้อมูล {this.state.type ? ` : ${this.state.type}` : ""}</b>
            </h4>
            <div className="card border-0 p-3 mb-3">
              <div className="bg-light card py-5 border-dashed">
                <div className="d-flex row w-100 justify-content-center my-5">
                  {cards.map((item, index) => (
                    <div key={index} className="card shadow mx-2 p-3 text-center wpx-200 pointer mb-3" onClick={() => window.location.href = item.link}>
                      <b className="icon text-primary" style={{ fontSize: 32 }}>{item.icon}</b>
                      <label className="pointer">{item.label}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}